export default __webpack_public_path__ + "static/media/paused-sub-bg.b5056815.png";